import GradientController from "./GradientController";

(() => {
    const initGradients = () => {
    
        const elements = Array.from(document.querySelectorAll('.three'));
    
        if (!elements.length) {
            console.warn('There is no gradient elements');
            return;
        }
    
        const gradientController = new GradientController();
        elements.forEach(el => {
            gradientController.add(el);
        });
    };
    
    initGradients();
})();
